import React from 'react';
import { intlShape } from 'common/components/intl/intlShape';
import LocalizedDayjs from 'common/localized_dayjs';

import Modal from 'common/components/modals/Modal';
import PropTypes from '../../propTypes';
import ConfirmationModalContentContainer from '../../containers/ConfirmationModalContentContainer';

class ConfirmationModal extends React.Component {
  static contextTypes = {
    intl: intlShape,
  };

  static propTypes = {
    formValues: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      day: PropTypes.string,
      month: PropTypes.string,
      year: PropTypes.string,
    }),
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
  };

  get legalName() {
    const { first_name, last_name } = this.props.formValues;
    return [first_name, last_name].join(' ');
  }

  get formattedDob() {
    const { day, month, year } = this.props.formValues;
    LocalizedDayjs.locale(this.context.intl.locale);
    return LocalizedDayjs(year + month + day, 'YYYYMMDD').format('LL');
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        bodyClassName="ConfirmationModal__body"
        className="ConfirmationModal"
        onRequestClose={this.props.onClose}
      >
        <ConfirmationModalContentContainer
          legalName={this.legalName}
          formattedDob={this.formattedDob}
          onConfirm={this.props.onConfirm}
          onClose={this.props.onClose}
        />
      </Modal>
    );
  }
}

export default ConfirmationModal;
